import React from "react";

function About({ content }) {
  const linkStyle = {
    color: "#010F7A",
    textDecoration: "none",
  };
  return (
    <div>
      <h1>Vishal Shenoy</h1>
      <p>
        I'm a student at{" "}
        <a href="https://ucdavis.edu" target="_blank" style={linkStyle}>
          UC Davis
        </a>
        , majoring in Computer Science. I'm building software at{" "}<a href="https://www.rox.com/launch" target="_blank" style={linkStyle}>Rox</a>{" "}this summer.
        <p> I enjoy creating simple and efficient technology with a focus on user experience.</p>
        Previously, I automated development workflows at{" "}
        <a href="https://codegen.com" target="_blank" style={linkStyle}>Codegen</a>,{" "} built low-level systems at{" "}
        <a href="https://tenstorrent.com" target="_blank" style={linkStyle}>Tenstorrent</a>, and{" "} developed internal tools for talent at {" "}
        <a href="https://conviction.com" target="_blank" style={linkStyle}>Conviction</a>.
      </p>
    </div>
  );
}

export default About;



